import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { withSlices } from 'zustand-slices';
import { authSlice } from './auth-slice';
import { addressSlice } from './address-slice';
import { shoppingCartSlice } from './shopping-cart-slice';
import { chatBotSlice } from './chatbot-slice';

/**
 * Temporal store that won't keep values in hard-reloads
 **/
export const useGlobalStore = create(
  devtools(
    withSlices(authSlice, addressSlice, shoppingCartSlice, chatBotSlice),
    {
      enabled: !import.meta.env.PROD,
    }
  )
);
